import React from "react";
import { Typography } from "./typography";
import { Asset } from "../../types/asset";

interface AssetRateDisplayProps {
  asset?: Asset;
  className?: string;
  showIcon?: boolean;
}

export const AssetRateDisplay: React.FC<AssetRateDisplayProps> = React.memo(
  ({ asset, className = "", showIcon = true }) => {
    if (!asset) return null;

    return (
      <div className={`flex items-center space-x-3 ${className}`}>
        {showIcon && (
          <img
            src={asset.image}
            alt={asset.assetName}
            className="w-6 h-6 rounded-full"
            aria-label={`${asset.assetName} icon`}
          />
        )}
        {/* <Typography variant="p" className="text-gray-600">
          R5,000 = {asset.asset} (rate from separate API)
        </Typography> */}
      </div>
    );
  }
);

AssetRateDisplay.displayName = "AssetRateDisplay";
